import { Base } from '@studiometa/js-toolkit';
import { sha256 } from 'js-sha256';

/**
 * ProductRecommendations
 */
export default class Newsletter extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Newsletter',
    refs: ['input', 'submitBtn', 'form', 'panelSuccess', 'close'],
    options: {
      template: String,
    },
  };

  /**
   *
   */
  mounted() {
    this.$refs.form.action = this.$refs.form.action.split('#')[0];
    if (this.$refs.panelSuccess) {
      this.$refs.panelSuccess.classList.remove('opacity-0', 'pointer-events-none');
    }
  }

  /**
   *
   */
  onCloseClick() {
    this.$refs.panelSuccess.classList.add('opacity-0', 'pointer-events-none');
  }

  /**
   *
   */
  onSubmitBtnClick() {
    window.dataLayer.push({
      event: 'newsletter_register',
      email_hashed: sha256(this.$refs.input.value),
      location: this.$options.template,
    });
  }
}
